const getNetEffectEstimate = (compositionResourceState) => {
    if (compositionResourceState?.section) {
        for (const section of compositionResourceState.section) {
            if (section.code?.text === 'Net Effect Estimate' ||
                section.code?.coding?.[0]?.code === "net-effect-estimate") {
                if (section.text?.div) {
                    return section.text.div;
                }
            }
        }
    }
};

export default getNetEffectEstimate;